import script from "./MantenedorEstudyooHub.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenedorEstudyooHub.vue?vue&type=script&setup=true&lang=js"

import "./MantenedorEstudyooHub.vue?vue&type=style&index=0&id=20491c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20491c96"]])

export default __exports__